import { AuthUser } from "aws-amplify/auth";
import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { useMyAccounts } from "../../account/hooks";
import { useNavigate } from "react-router-dom";
import LoadingOverlay from "../../_app/components/LoadingOverlay";

const SignInRedirect = ({ user }: { user?: AuthUser }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  // Wait for the Authenticator.Provider machine to process the Hub `signedIn` event before
  // navigating — otherwise PrivateRoute (authStatus !== "authenticated") bounces us back to /login.
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  useMyAccounts();

  useEffect(() => {
    if (user && authStatus === "authenticated") {
      queryClient.resetQueries();
      navigate("/");
    }
  }, [user, authStatus, navigate, queryClient]);

  // Keep a visible loader while waiting for the Authenticator machine — a bare null here means
  // a blank white page between the login screen unmounting and the app rendering.
  return <LoadingOverlay />;
};

export default SignInRedirect;
